import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(({ tokens, breakpoints }) => ({
  content: {
    paddingLeft: tokens.spacing['16'],
    paddingRight: tokens.spacing['16'],
    [breakpoints.up('md')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
}));
